import { BaseEncoder } from "./BaseEncoder";
import { BaseObjectEncoder } from "./BaseObjectEncoder";
import { DefaultBaseObjectEncoderImpl } from "./DefaultBaseObjectEncoderImpl";

import { OrderRequestDataImpl } from "../model/impl/OrderRequestDataImpl";
import { Encodable } from "../model/Encodable";

import * as CubiqTS from "../index";

export class OrderRequestDataImplEncoder implements BaseEncoder {
  public baseEncoder: BaseObjectEncoder = new DefaultBaseObjectEncoderImpl();

  private static _instance;

  private constructor() {}

  public static get Instance() {
    // Do you need arguments? Make it a regular method instead.
    return this._instance || (this._instance = new this());
  }

  public encode(encodable: OrderRequestDataImpl, streamout: CubiqTS.ByteBuffer): void {
    this.baseEncoder.encode(encodable, streamout);

    this.baseEncoder.writeStartEncoding(streamout);

    /*Object encoding*/
    if (encodable.accountCode != null) {
      this.baseEncoder.writeStartFid(1, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderRequestDataImplEncoder.fidTypeMap.get(1),
        false,
        encodable.accountCode,
        streamout,
      );
      this.baseEncoder.writeEndFid(1, streamout);
    }
    /*Object encoding*/
    if (encodable.activationDetailUtc != null) {
      this.baseEncoder.writeStartFid(2, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderRequestDataImplEncoder.fidTypeMap.get(2),
        false,
        encodable.activationDetailUtc,
        streamout,
      );
      this.baseEncoder.writeEndFid(2, streamout);
    }
    /*Object encoding*/
    if (encodable.base != null) {
      this.baseEncoder.writeStartFid(3, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderRequestDataImplEncoder.fidTypeMap.get(3),
        false,
        encodable.base,
        streamout,
      );
      this.baseEncoder.writeEndFid(3, streamout);
    }
    /*Object encoding*/
    if (encodable.clientCode != null) {
      this.baseEncoder.writeStartFid(4, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderRequestDataImplEncoder.fidTypeMap.get(4),
        false,
        encodable.clientCode,
        streamout,
      );
      this.baseEncoder.writeEndFid(4, streamout);
    }
    /*Object encoding*/
    if (encodable.comment != null) {
      this.baseEncoder.writeStartFid(5, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderRequestDataImplEncoder.fidTypeMap.get(5),
        false,
        encodable.comment,
        streamout,
      );
      this.baseEncoder.writeEndFid(5, streamout);
    }
    /*Object encoding*/
    if (encodable.comment2 != null) {
      this.baseEncoder.writeStartFid(6, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderRequestDataImplEncoder.fidTypeMap.get(6),
        false,
        encodable.comment2,
        streamout,
      );
      this.baseEncoder.writeEndFid(6, streamout);
    }
    /*Object encoding*/
    if (encodable.expiryDetailUtc != null) {
      this.baseEncoder.writeStartFid(7, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderRequestDataImplEncoder.fidTypeMap.get(7),
        false,
        encodable.expiryDetailUtc,
        streamout,
      );
      this.baseEncoder.writeEndFid(7, streamout);
    }
    /*Object encoding*/
    if (encodable.externalClientReference != null) {
      this.baseEncoder.writeStartFid(8, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderRequestDataImplEncoder.fidTypeMap.get(8),
        false,
        encodable.externalClientReference,
        streamout,
      );
      this.baseEncoder.writeEndFid(8, streamout);
    }
    /*Object encoding*/
    if (encodable.fillSupport != null) {
      this.baseEncoder.writeStartFid(9, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderRequestDataImplEncoder.fidTypeMap.get(9),
        false,
        encodable.fillSupport,
        streamout,
      );
      this.baseEncoder.writeEndFid(9, streamout);
    }
    /*Object encoding*/
    if (encodable.fillTypeRestriction != null) {
      this.baseEncoder.writeStartFid(10, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderRequestDataImplEncoder.fidTypeMap.get(10),
        false,
        encodable.fillTypeRestriction,
        streamout,
      );
      this.baseEncoder.writeEndFid(10, streamout);
    }
    /*Object encoding*/
    if (encodable.fixedAmount != null) {
      this.baseEncoder.writeStartFid(11, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderRequestDataImplEncoder.fidTypeMap.get(11),
        false,
        encodable.fixedAmount,
        streamout,
      );
      this.baseEncoder.writeEndFid(11, streamout);
    }
    /*Object encoding*/
    if (encodable.fixedCcy != null) {
      this.baseEncoder.writeStartFid(12, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderRequestDataImplEncoder.fidTypeMap.get(12),
        false,
        encodable.fixedCcy,
        streamout,
      );
      this.baseEncoder.writeEndFid(12, streamout);
    }
    /*Object encoding*/
    if (encodable.fixingDate != null) {
      this.baseEncoder.writeStartFid(13, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderRequestDataImplEncoder.fidTypeMap.get(13),
        true,
        encodable.fixingDate,
        streamout,
      );
      this.baseEncoder.writeEndFid(13, streamout);
    }
    /*Object encoding*/
    if (encodable.fixingSource != null) {
      this.baseEncoder.writeStartFid(14, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderRequestDataImplEncoder.fidTypeMap.get(14),
        false,
        encodable.fixingSource,
        streamout,
      );
      this.baseEncoder.writeEndFid(14, streamout);
    }
    /*Object encoding*/
    if (encodable.forwardTrackingType != null) {
      this.baseEncoder.writeStartFid(15, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderRequestDataImplEncoder.fidTypeMap.get(15),
        false,
        encodable.forwardTrackingType,
        streamout,
      );
      this.baseEncoder.writeEndFid(15, streamout);
    }
    /*Object encoding*/
    if (encodable.markup != null) {
      this.baseEncoder.writeStartFid(16, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderRequestDataImplEncoder.fidTypeMap.get(16),
        false,
        encodable.markup,
        streamout,
      );
      this.baseEncoder.writeEndFid(16, streamout);
    }
    /*Object encoding*/
    if (encodable.nonBase != null) {
      this.baseEncoder.writeStartFid(17, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderRequestDataImplEncoder.fidTypeMap.get(17),
        false,
        encodable.nonBase,
        streamout,
      );
      this.baseEncoder.writeEndFid(17, streamout);
    }
    /*Object encoding*/
    if (encodable.orderId != null) {
      this.baseEncoder.writeStartFid(18, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderRequestDataImplEncoder.fidTypeMap.get(18),
        false,
        encodable.orderId,
        streamout,
      );
      this.baseEncoder.writeEndFid(18, streamout);
    }
    /*Object encoding*/
    if (encodable.orderType != null) {
      this.baseEncoder.writeStartFid(19, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderRequestDataImplEncoder.fidTypeMap.get(19),
        false,
        encodable.orderType,
        streamout,
      );
      this.baseEncoder.writeEndFid(19, streamout);
    }
    /*Object encoding*/
    if (encodable.product != null) {
      this.baseEncoder.writeStartFid(20, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderRequestDataImplEncoder.fidTypeMap.get(20),
        false,
        encodable.product,
        streamout,
      );
      this.baseEncoder.writeEndFid(20, streamout);
    }
    /*Object encoding*/
    if (encodable.requestOrderType != null) {
      this.baseEncoder.writeStartFid(21, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderRequestDataImplEncoder.fidTypeMap.get(21),
        false,
        encodable.requestOrderType,
        streamout,
      );
      this.baseEncoder.writeEndFid(21, streamout);
    }
    /*Object encoding*/
    if (encodable.requestRate != null) {
      this.baseEncoder.writeStartFid(22, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderRequestDataImplEncoder.fidTypeMap.get(22),
        false,
        encodable.requestRate,
        streamout,
      );
      this.baseEncoder.writeEndFid(22, streamout);
    }
    /*Object encoding*/
    if (encodable.slippage != null) {
      this.baseEncoder.writeStartFid(23, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderRequestDataImplEncoder.fidTypeMap.get(23),
        false,
        encodable.slippage,
        streamout,
      );
      this.baseEncoder.writeEndFid(23, streamout);
    }
    /*Object encoding*/
    if (encodable.stpHold != null) {
      this.baseEncoder.writeStartFid(24, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderRequestDataImplEncoder.fidTypeMap.get(24),
        false,
        encodable.stpHold,
        streamout,
      );
      this.baseEncoder.writeEndFid(24, streamout);
    }
    /*Object encoding*/
    if (encodable.strategyParameters != null) {
      this.baseEncoder.writeStartFid(25, streamout);
      this.baseEncoder.writeObject(
        true,
        OrderRequestDataImplEncoder.fidTypeMap.get(25),
        false,
        encodable.strategyParameters,
        streamout,
      );
      this.baseEncoder.writeEndFid(25, streamout);
    }
    /*Object encoding*/
    if (encodable.tenor != null) {
      this.baseEncoder.writeStartFid(26, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderRequestDataImplEncoder.fidTypeMap.get(26),
        false,
        encodable.tenor,
        streamout,
      );
      this.baseEncoder.writeEndFid(26, streamout);
    }
    /*Object encoding*/
    if (encodable.traderGroup != null) {
      this.baseEncoder.writeStartFid(27, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderRequestDataImplEncoder.fidTypeMap.get(27),
        false,
        encodable.traderGroup,
        streamout,
      );
      this.baseEncoder.writeEndFid(27, streamout);
    }
    /*Object encoding*/
    if (encodable.tradingChannel != null) {
      this.baseEncoder.writeStartFid(28, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderRequestDataImplEncoder.fidTypeMap.get(28),
        false,
        encodable.tradingChannel,
        streamout,
      );
      this.baseEncoder.writeEndFid(28, streamout);
    }
    /*Object encoding*/
    if (encodable.tslDistancePips != null) {
      this.baseEncoder.writeStartFid(29, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderRequestDataImplEncoder.fidTypeMap.get(29),
        false,
        encodable.tslDistancePips,
        streamout,
      );
      this.baseEncoder.writeEndFid(29, streamout);
    }
    /*Object encoding*/
    if (encodable.tslStartRate != null) {
      this.baseEncoder.writeStartFid(30, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderRequestDataImplEncoder.fidTypeMap.get(30),
        false,
        encodable.tslStartRate,
        streamout,
      );
      this.baseEncoder.writeEndFid(30, streamout);
    }
    /*Object encoding*/
    if (encodable.valueDate != null) {
      this.baseEncoder.writeStartFid(31, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderRequestDataImplEncoder.fidTypeMap.get(31),
        true,
        encodable.valueDate,
        streamout,
      );
      this.baseEncoder.writeEndFid(31, streamout);
    }
    /*Object encoding*/
    if (encodable.isPrivateOrder != null) {
      this.baseEncoder.writeStartFid(32, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderRequestDataImplEncoder.fidTypeMap.get(32),
        false,
        encodable.isPrivateOrder,
        streamout,
      );
      this.baseEncoder.writeEndFid(32, streamout);
    }
    /*Object encoding*/
    if (encodable.clientIntent != null) {
      this.baseEncoder.writeStartFid(33, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderRequestDataImplEncoder.fidTypeMap.get(33),
        false,
        encodable.clientIntent,
        streamout,
      );
      this.baseEncoder.writeEndFid(33, streamout);
    }
    /*Object encoding*/
    if (encodable.childRelationships != null) {
      this.baseEncoder.writeStartFid(34, streamout);

      let size: number = encodable.childRelationships.length;
      this.baseEncoder.writeInt(size, streamout);

      for (let i: number = 0; i < size; i++) {
        let order: OrderRequestDataImpl = encodable.childRelationships[i].order;
        this.baseEncoder.writeObject(
          false,
          OrderRequestDataImplEncoder.fidTypeMap.get(34),
          true,
          encodable.childRelationships[i],
          streamout,
        );
        this.baseEncoder.writeObject(false, OrderRequestDataImpl.enType, true, order, streamout);
      }

      this.baseEncoder.writeEndFid(34, streamout);
    }
    /*Object encoding*/
    if (encodable.sibling != null) {
      this.baseEncoder.writeStartFid(35, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderRequestDataImplEncoder.fidTypeMap.get(35),
        true,
        encodable.sibling,
        streamout,
      );
      this.baseEncoder.writeObject(
        false,
        CubiqTS.LinkedRelationshipImpl.enType,
        true,
        encodable.sibling.order,
        streamout,
      );
      this.baseEncoder.writeEndFid(35, streamout);
    }
    /*Object encoding*/
    if (encodable.useDefaultClientDataFg != null) {
      this.baseEncoder.writeStartFid(36, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderRequestDataImplEncoder.fidTypeMap.get(36),
        false,
        encodable.useDefaultClientDataFg,
        streamout,
      );
      this.baseEncoder.writeEndFid(36, streamout);
    }
    /*Object encoding*/
    if (encodable.clientContacts != null) {
      this.baseEncoder.writeStartFid(37, streamout);
      this.baseEncoder.writeObject(
        true,
        OrderRequestDataImplEncoder.fidTypeMap.get(37),
        false,
        encodable.clientContacts,
        streamout,
      );
      this.baseEncoder.writeEndFid(37, streamout);
    }
    if (encodable.activationDetails != null) {
      this.baseEncoder.writeStartFid(38, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderRequestDataImplEncoder.fidTypeMap.get(38),
        true,
        encodable.activationDetails,
        streamout,
      );
      this.baseEncoder.writeEndFid(38, streamout);
    }
    if (encodable.expiryDetails != null) {
      this.baseEncoder.writeStartFid(39, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderRequestDataImplEncoder.fidTypeMap.get(39),
        true,
        encodable.expiryDetails,
        streamout,
      );
      this.baseEncoder.writeEndFid(39, streamout);
    }
    /*Object encoding*/
    if (encodable.customValues != null) {
      this.baseEncoder.writeStartFid(40, streamout);
      this.baseEncoder.writeObject(
        true,
        OrderRequestDataImplEncoder.fidTypeMap.get(40),
        false,
        encodable.customValues,
        streamout,
      );
      this.baseEncoder.writeEndFid(40, streamout);
    }
    if (encodable.markupType != null) {
      this.baseEncoder.writeStartFid(41, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderRequestDataImplEncoder.fidTypeMap.get(41),
        false,
        encodable.markupType,
        streamout,
      );
      this.baseEncoder.writeEndFid(41, streamout);
    }
    if (encodable.fixingCode != null) {
      this.baseEncoder.writeStartFid(42, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderRequestDataImplEncoder.fidTypeMap.get(42),
        false,
        encodable.fixingCode,
        streamout,
      );
      this.baseEncoder.writeEndFid(42, streamout);
    }
    if (encodable.fixingTime != null) {
      this.baseEncoder.writeStartFid(43, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderRequestDataImplEncoder.fidTypeMap.get(43),
        true,
        encodable.fixingTime,
        streamout,
      );
      this.baseEncoder.writeEndFid(43, streamout);
    }
    if (encodable.algoProfileId != null) {
      this.baseEncoder.writeStartFid(44, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderRequestDataImplEncoder.fidTypeMap.get(44),
        false,
        encodable.algoProfileId,
        streamout,
      );
      this.baseEncoder.writeEndFid(44, streamout);
    }
    /*Object encoding*/
    if (encodable.passthroughParameters != null) {
      this.baseEncoder.writeStartFid(45, streamout);
      this.baseEncoder.writeObject(
        true,
        OrderRequestDataImplEncoder.fidTypeMap.get(45),
        false,
        encodable.passthroughParameters,
        streamout,
      );
      this.baseEncoder.writeEndFid(45, streamout);
    }
    /*Object encoding*/
    if (encodable.stpAggregationEnabled != null) {
      this.baseEncoder.writeStartFid(46, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderRequestDataImplEncoder.fidTypeMap.get(46),
        false,
        encodable.stpAggregationEnabled,
        streamout,
      );
      this.baseEncoder.writeEndFid(46, streamout);
    }
    /*Object encoding*/
    if (encodable.algoStrategyName != null) {
      this.baseEncoder.writeStartFid(47, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderRequestDataImplEncoder.fidTypeMap.get(47),
        false,
        encodable.algoStrategyName,
        streamout,
      );
      this.baseEncoder.writeEndFid(47, streamout);
    }
    /*Object encoding*/
    if (encodable.oboClient != null) {
      this.baseEncoder.writeStartFid(48, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderRequestDataImplEncoder.fidTypeMap.get(48),
        false,
        encodable.oboClient,
        streamout,
      );
      this.baseEncoder.writeEndFid(48, streamout);
    }
    /*Object encoding*/
    if (encodable.oboAccount != null) {
      this.baseEncoder.writeStartFid(49, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderRequestDataImplEncoder.fidTypeMap.get(49),
        false,
        encodable.oboAccount,
        streamout,
      );
      this.baseEncoder.writeEndFid(49, streamout);
    }
    /*Object encoding*/
    if (encodable.orderRef != null) {
      this.baseEncoder.writeStartFid(50, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderRequestDataImplEncoder.fidTypeMap.get(50),
        false,
        encodable.orderRef,
        streamout,
      );
      this.baseEncoder.writeEndFid(50, streamout);
    }
    /*Object encoding*/
    if (encodable.autoForwardPricing != null) {
      this.baseEncoder.writeStartFid(51, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderRequestDataImplEncoder.fidTypeMap.get(51),
        false,
        encodable.autoForwardPricing,
        streamout,
      );
      this.baseEncoder.writeEndFid(51, streamout);
    }
    /*Object encoding*/
    if (encodable.messageId != null) {
      this.baseEncoder.writeStartFid(100, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderRequestDataImplEncoder.fidTypeMap.get(100),
        false,
        encodable.messageId,
        streamout,
      );
      this.baseEncoder.writeEndFid(100, streamout);
    }
    /*Object encoding*/
    if(encodable.sessionOnly!=null){
        this.baseEncoder.writeStartFid(10010,streamout);
        this.baseEncoder.writeObject(false,OrderRequestDataImplEncoder.fidTypeMap.get(10010),false,encodable.sessionOnly,streamout);
        this.baseEncoder.writeEndFid(10010,streamout);
    }
    this.baseEncoder.writeEndEncoding(streamout);
  }

  static fidTypeMap: Map<number, string> = new Map<number, string>([
    [1, "java.lang.String"],
    [2, "java.util.Calendar"],
    [3, "java.lang.String"],
    [4, "java.lang.String"],
    [5, "java.lang.String"],
    [6, "java.lang.String"],
    [7, "java.util.Calendar"],
    [8, "java.lang.String"],
    [9, "com.bcdfx.model.FillSupport"],
    [10, "com.bcdfx.model.RequestorFillTypeRestriction"],
    [11, "java.lang.String"],
    [12, "java.lang.String"],
    [13, "com.bcdfx.model.StandardDate"],
    [14, "java.lang.String"],
    [15, "com.bcdfx.model.RequestTrackingType"],
    [16, "java.lang.String"],
    [17, "java.lang.String"],
    [18, "java.lang.String"],
    [19, "com.bcdfx.model.OrderType"],
    [20, "com.bcdfx.model.Product"],
    [21, "com.bcdfx.model.RequestOrderType"],
    [22, "java.lang.String"],
    [23, "java.lang.String"],
    [24, "java.lang.Boolean"],
    [25, "com.bcdfx.model.event.lifecycle.StrategyParameterImpl"],
    [26, "com.bcdfx.model.Tenor"],
    [27, "java.lang.String"],
    [28, "java.lang.String"],
    [29, "java.lang.String"],
    [30, "java.lang.String"],
    [31, "com.bcdfx.model.StandardDate"],
    [32, "java.lang.Boolean"],
    [33, "com.bcdfx.model.OrderIntent"],
    [34, "com.bcdfx.model.event.lifecycle.LinkedRelationshipImpl"],
    [35, "com.bcdfx.model.event.lifecycle.LinkedRelationshipImpl"],
    [36, "java.lang.Boolean"],
    [37, "java.lang.Long"],
    [38, "com.bcdfx.model.ActivationDetailsImpl"],
    [39, "com.bcdfx.model.ExpiryDetailsImpl"],
    [40, "com.bcdfx.model.CustomValue"],
    [41, "com.bcdfx.model.MarkUpType"],
    [42, "java.lang.String"],
    [43, "com.bcdfx.model.StandardTime"],
    [44, "java.lang.String"],
    [45, "com.bcdfx.model.event.lifecycle.StrategyParameterImpl"],
    [46, "java.lang.Boolean"],
    [47, "java.lang.String"],
    [48, "java.lang.String"],
    [49, "java.lang.String"],
    [50, "java.lang.String"],
    [51, "java.lang.Boolean"],
    [100, "java.lang.String"],
    [10010, "java.lang.String"],
  ]);

  /**
   * Constructs the event from a given byte stream
   */
  public decode(encodable: OrderRequestDataImpl, streamin: CubiqTS.ByteBuffer): void {
    this.baseEncoder.decode(encodable, streamin);

    while (true) {
      let ct: string = this.baseEncoder.readCtrl(streamin);
      if (ct == "^F") {
        break;
      }
      if (ct == "^H") continue;
      let fid: number = this.baseEncoder.parseCtrlAsFid(ct);
      if (this.supportsFid(fid) == false) this.baseEncoder.seekToNextFid(fid, streamin);
      switch (fid) {
        case 1: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            OrderRequestDataImplEncoder.fidTypeMap.get(1),
            streamin,
          );
          encodable.accountCode = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 2: {
          /*Object encoding*/
          let val: CubiqTS.moment.Moment = this.baseEncoder.readObject(
            false,
            false,
            OrderRequestDataImplEncoder.fidTypeMap.get(2),
            streamin,
          );
          encodable.activationDetailUtc = <CubiqTS.moment.Moment>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 3: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            OrderRequestDataImplEncoder.fidTypeMap.get(3),
            streamin,
          );
          encodable.base = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 4: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            OrderRequestDataImplEncoder.fidTypeMap.get(4),
            streamin,
          );
          encodable.clientCode = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 5: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            OrderRequestDataImplEncoder.fidTypeMap.get(5),
            streamin,
          );
          encodable.comment = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 6: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            OrderRequestDataImplEncoder.fidTypeMap.get(6),
            streamin,
          );
          encodable.comment2 = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 7: {
          /*Object encoding*/
          let val: CubiqTS.moment.Moment = this.baseEncoder.readObject(
            false,
            false,
            OrderRequestDataImplEncoder.fidTypeMap.get(7),
            streamin,
          );
          encodable.expiryDetailUtc = <CubiqTS.moment.Moment>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 8: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            OrderRequestDataImplEncoder.fidTypeMap.get(8),
            streamin,
          );
          encodable.externalClientReference = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 9: {
          /*Object encoding*/
          let val: CubiqTS.FillSupport = this.baseEncoder.readObject(
            false,
            false,
            OrderRequestDataImplEncoder.fidTypeMap.get(9),
            streamin,
          );
          encodable.fillSupport = <CubiqTS.FillSupport>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 10: {
          /*Object encoding*/
          let val: CubiqTS.RequestorFillTypeRestriction = this.baseEncoder.readObject(
            false,
            false,
            OrderRequestDataImplEncoder.fidTypeMap.get(10),
            streamin,
          );
          encodable.fillTypeRestriction = <CubiqTS.RequestorFillTypeRestriction>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 11: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            OrderRequestDataImplEncoder.fidTypeMap.get(11),
            streamin,
          );
          encodable.fixedAmount = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 12: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            OrderRequestDataImplEncoder.fidTypeMap.get(12),
            streamin,
          );
          encodable.fixedCcy = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 13: {
          /*Object encoding*/
          let val: CubiqTS.StandardDate = this.baseEncoder.readObject(
            true,
            false,
            OrderRequestDataImplEncoder.fidTypeMap.get(13),
            streamin,
          );
          encodable.fixingDate = <CubiqTS.StandardDate>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 14: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            OrderRequestDataImplEncoder.fidTypeMap.get(14),
            streamin,
          );
          encodable.fixingSource = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 15: {
          /*Object encoding*/
          let val: CubiqTS.RequestTrackingType = this.baseEncoder.readObject(
            false,
            false,
            OrderRequestDataImplEncoder.fidTypeMap.get(15),
            streamin,
          );
          encodable.forwardTrackingType = <CubiqTS.RequestTrackingType>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 16: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            OrderRequestDataImplEncoder.fidTypeMap.get(16),
            streamin,
          );
          encodable.markup = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 17: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            OrderRequestDataImplEncoder.fidTypeMap.get(17),
            streamin,
          );
          encodable.nonBase = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 18: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            OrderRequestDataImplEncoder.fidTypeMap.get(18),
            streamin,
          );
          encodable.orderId = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 19: {
          /*Object encoding*/
          let val: CubiqTS.OrderType = this.baseEncoder.readObject(
            false,
            false,
            OrderRequestDataImplEncoder.fidTypeMap.get(19),
            streamin,
          );
          encodable.orderType = <CubiqTS.OrderType>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 20: {
          /*Object encoding*/
          let val: CubiqTS.Product = this.baseEncoder.readObject(
            false,
            false,
            OrderRequestDataImplEncoder.fidTypeMap.get(20),
            streamin,
          );
          encodable.product = <CubiqTS.Product>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 21: {
          /*Object encoding*/
          let val: CubiqTS.RequestOrderType = this.baseEncoder.readObject(
            false,
            false,
            OrderRequestDataImplEncoder.fidTypeMap.get(21),
            streamin,
          );
          encodable.requestOrderType = <CubiqTS.RequestOrderType>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 22: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            OrderRequestDataImplEncoder.fidTypeMap.get(22),
            streamin,
          );
          encodable.requestRate = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 23: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            OrderRequestDataImplEncoder.fidTypeMap.get(23),
            streamin,
          );
          encodable.slippage = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 24: {
          /*Object encoding*/
          let val: boolean = this.baseEncoder.readObject(
            false,
            false,
            OrderRequestDataImplEncoder.fidTypeMap.get(24),
            streamin,
          );
          encodable.stpHold = <boolean>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 25: {
          /*Object encoding*/
          let val: Array<CubiqTS.StrategyParameterImpl> = this.baseEncoder.readObject(
            false,
            true,
            OrderRequestDataImplEncoder.fidTypeMap.get(25),
            streamin,
          );
          encodable.strategyParameters = <Array<CubiqTS.StrategyParameterImpl>>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 26: {
          /*Object encoding*/
          let val: CubiqTS.Tenor = this.baseEncoder.readObject(
            false,
            false,
            OrderRequestDataImplEncoder.fidTypeMap.get(26),
            streamin,
          );
          encodable.tenor = <CubiqTS.Tenor>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 27: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            OrderRequestDataImplEncoder.fidTypeMap.get(27),
            streamin,
          );
          encodable.traderGroup = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 28: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            OrderRequestDataImplEncoder.fidTypeMap.get(28),
            streamin,
          );
          encodable.tradingChannel = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 29: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            OrderRequestDataImplEncoder.fidTypeMap.get(29),
            streamin,
          );
          encodable.tslDistancePips = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 30: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            OrderRequestDataImplEncoder.fidTypeMap.get(30),
            streamin,
          );
          encodable.tslStartRate = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 31: {
          /*Object encoding*/
          let val: CubiqTS.StandardDate = this.baseEncoder.readObject(
            true,
            false,
            OrderRequestDataImplEncoder.fidTypeMap.get(31),
            streamin,
          );
          encodable.valueDate = <CubiqTS.StandardDate>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 32: {
          /*Object encoding*/
          let val: boolean = this.baseEncoder.readObject(
            false,
            false,
            OrderRequestDataImplEncoder.fidTypeMap.get(32),
            streamin,
          );
          encodable.isPrivateOrder = <boolean>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 33: {
          /*Object encoding*/
          let val: CubiqTS.OrderIntent = this.baseEncoder.readObject(
            false,
            false,
            OrderRequestDataImplEncoder.fidTypeMap.get(33),
            streamin,
          );
          encodable.clientIntent = <CubiqTS.OrderIntent>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 34: {
          /*Object encoding*/
          let size: number = this.baseEncoder.readInt(streamin);
          encodable.childRelationships = [];

          for (let i: number = 0; i < size; i++) {
            let linkedRelationship: CubiqTS.LinkedRelationshipImpl = this.baseEncoder.readObject(
              true,
              false,
              OrderRequestDataImplEncoder.fidTypeMap.get(34),
              streamin,
            );
            let orderData: CubiqTS.OrderRequestDataImpl = this.baseEncoder.readObject(
              true,
              false,
              OrderRequestDataImpl.enType,
              streamin,
            );
            linkedRelationship.order = orderData;
            encodable.childRelationships.push(linkedRelationship);
          }

          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 35: {
          /*Object encoding*/
          let val: CubiqTS.LinkedRelationshipImpl = this.baseEncoder.readObject(
            true,
            false,
            OrderRequestDataImplEncoder.fidTypeMap.get(35),
            streamin,
          );
          let orderData: CubiqTS.OrderRequestDataImpl = this.baseEncoder.readObject(
            true,
            false,
            OrderRequestDataImpl.enType,
            streamin,
          );
          val.order = orderData;
          encodable.sibling = <CubiqTS.LinkedRelationshipImpl>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 36: {
          /*Object encoding*/
          let val: boolean = this.baseEncoder.readObject(
            false,
            false,
            OrderRequestDataImplEncoder.fidTypeMap.get(36),
            streamin,
          );
          encodable.useDefaultClientDataFg = <boolean>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 37: {
          /*Object encoding*/
          let val: Array<CubiqTS.Long> = this.baseEncoder.readObject(
            false,
            true,
            OrderRequestDataImplEncoder.fidTypeMap.get(37),
            streamin,
          );
          encodable.clientContacts = <Array<CubiqTS.Long>>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 38: {
          /*Object encoding*/
          let val: CubiqTS.ActivationDetailsImpl = this.baseEncoder.readObject(
            true,
            false,
            OrderRequestDataImplEncoder.fidTypeMap.get(38),
            streamin,
          );
          encodable.activationDetails = <CubiqTS.ActivationDetailsImpl>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 39: {
          /*Object encoding*/
          let val: CubiqTS.ExpiryDetailsImpl = this.baseEncoder.readObject(
            true,
            false,
            OrderRequestDataImplEncoder.fidTypeMap.get(39),
            streamin,
          );
          encodable.expiryDetails = <CubiqTS.ExpiryDetailsImpl>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 40: {
          /*Object encoding*/
          let val: Array<CubiqTS.CustomValue> = this.baseEncoder.readObject(
            false,
            true,
            OrderRequestDataImplEncoder.fidTypeMap.get(40),
            streamin,
          );
          encodable.customValues = <Array<CubiqTS.CustomValue>>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 41: {
          /*Object encoding*/
          let val: CubiqTS.MarkUpType = this.baseEncoder.readObject(
            false,
            false,
            OrderRequestDataImplEncoder.fidTypeMap.get(41),
            streamin,
          );
          encodable.markupType = <CubiqTS.MarkUpType>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 42: {
          /*Object encoding*/
          encodable.fixingCode = this.baseEncoder.readObject(
            false,
            false,
            OrderRequestDataImplEncoder.fidTypeMap.get(42),
            streamin,
          );
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 43: {
          /*Object encoding*/
          let val: CubiqTS.StandardTime = this.baseEncoder.readObject(
            true,
            false,
            OrderRequestDataImplEncoder.fidTypeMap.get(43),
            streamin,
          );
          encodable.fixingTime = <CubiqTS.StandardTime>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 44: {
          /*Object encoding*/
          encodable.algoProfileId = this.baseEncoder.readObject(
            false,
            false,
            OrderRequestDataImplEncoder.fidTypeMap.get(44),
            streamin,
          );
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 45: {
          /*Object encoding*/
          let val: Array<CubiqTS.StrategyParameterImpl> = this.baseEncoder.readObject(
            false,
            true,
            OrderRequestDataImplEncoder.fidTypeMap.get(45),
            streamin,
          );
          encodable.passthroughParameters = <Array<CubiqTS.StrategyParameterImpl>>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 46: {
          /*Object encoding*/
          let val: boolean = this.baseEncoder.readObject(
            false,
            false,
            OrderRequestDataImplEncoder.fidTypeMap.get(46),
            streamin,
          );
          encodable.stpAggregationEnabled = <boolean>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 47: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            OrderRequestDataImplEncoder.fidTypeMap.get(47),
            streamin,
          );
          encodable.algoStrategyName = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 48: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            OrderRequestDataImplEncoder.fidTypeMap.get(48),
            streamin,
          );
          encodable.oboClient = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 49: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            OrderRequestDataImplEncoder.fidTypeMap.get(49),
            streamin,
          );
          encodable.oboAccount = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 50: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            OrderRequestDataImplEncoder.fidTypeMap.get(50),
            streamin,
          );
          encodable.orderRef = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 51: {
          /*Object encoding*/
          let val: boolean = this.baseEncoder.readObject(
            false,
            false,
            OrderRequestDataImplEncoder.fidTypeMap.get(51),
            streamin,
          );
          encodable.autoForwardPricing = <boolean>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 100: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            OrderRequestDataImplEncoder.fidTypeMap.get(100),
            streamin,
          );
          encodable.messageId = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 10010: {
          /*Object encoding*/
          let val_10010:string=this.baseEncoder.readObject(false,false,OrderRequestDataImplEncoder.fidTypeMap.get(10010),streamin);
          encodable.sessionOnly=val_10010;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
      }
    }
  }

  private supportsFid(fid: number): boolean {
    return OrderRequestDataImplEncoder.fidTypeMap.has(fid);
  }
}
